<section class=" banner2-container">
  <div class="container">
    <div class="row">
      <div class="col-60 col-md-30 col-lg-25 d-flex flex-column justify-content-center">
        <h6 class="section-title elsa-title-font" [class.mb-5]="!description" [class.mb-md-0]="!description">{{title}}</h6>
        <div class="section-description" [innerHTML]="description|safeHtml" *ngIf="description">
        </div>
      </div>
      <div class="d-none d-md-block col-60 col-md-30 col-lg-35 position-relative">
        <div class="banner-container" [ngStyle]="{'background-image': 'url('+img+')'}"></div>
      </div>
    </div>
  </div>
</section>
